import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { FlexBox } from "../flexBox/FlexBox.js";
import { combineClasses } from "../../utilities/combineClasses.js";
import Paper_module from "./Paper.module.js";
const Paper = /*#__PURE__*/ forwardRef(({ children, className, shadow = false, noBorderRadius = false, noMargin = false, ...rest }, ref)=>/*#__PURE__*/ jsx(FlexBox, {
        className: combineClasses(Paper_module.paper, shadow && Paper_module.shadow, !noBorderRadius && Paper_module.rounded, noMargin && Paper_module.noMargin, className),
        ref: ref,
        ...rest,
        children: children
    }));
Paper.displayName = 'Paper';
export { Paper };
